@import '../../../theme.scss';

verdocs-template-roles {
  display: block;
  max-width: 600px;
  font-family: $verdocs-primary-font;

  .roles {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;

    .sequence {
      gap: 10px;
      //height: 34px;
      display: flex;
      flex-wrap: wrap;
      font-weight: 500;
      padding: 0 0 8px 0;
      flex-direction: row;
      border-bottom: 1px dotted #e3e3e3;

      &.add-sequence {
        color: #777777;
        line-height: 34px;
      }
    }

    .sequence-label {
      font-size: 18px;
      line-height: 32px;
    }

    .sequence-roles {
      gap: 10px;
      display: flex;
      position: relative;
      flex-wrap: wrap;
      flex-direction: row;
    }

    .role {
      height: 32px;
      cursor: move;
      display: flex;
      max-width: 200px;
      position: relative;
      border-radius: 32px;
      background-color: #eff7fb;
      box-sizing: border-box;
      padding: 0 14px 0 34px;
      border: 1px solid #ccc;
      flex-direction: column;

      .role-name {
        font-size: 14px;
        overflow: hidden;
        font-weight: 400;
        line-height: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .icons {
        position: absolute;
        left: 1px;
        top: -3px;
        cursor: pointer;
        padding: 5px;
        z-index: 10;

        .gear-button {
          display: none;
          transform: scale(1.1);
          margin: 4px 0 0 1px;
        }

        .type-icon {
          opacity: 0.6;
          display: block;
          transform: scale(0.8);
        }

        &:hover {
          .gear-button {
            display: block;
          }

          .type-icon {
            display: none;
          }
        }
      }
    }
  }

  > form {
    display: flex;
    flex-direction: column;
    background-color: $verdocs-grey-4;

    // The extra right padding helps ensure when dragged elements move to absolute positioning
    padding: 12px;

    h5 {
      font-size: 16px;
      font-weight: bold;
      color: $verdocs-grey-blue;
      margin: 0 0 10px 0;
    }

    label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      margin: 0 0 4px 0;
      color: $verdocs-bg-4;
    }

    input {
      border: none;
      font-size: 18px;
      padding: 3px 6px 3px 0;
      background: transparent;
      border-bottom: 1px solid $verdocs-dark-blue;

      &:focus {
        outline: none;
      }
    }
  }

  .row.add-sequence {
    display: none;
  }

  .add-role {
    opacity: 0.3;
    padding: 0 10px;
    cursor: pointer;
    background: none;
    height: 32px;
    border: 1px solid #cccccc;
    border-radius: 32px;

    //transform: scale(0.75);

    &:hover {
      opacity: 1;
    }

    //svg {
    //  width: 32px;
    //  height: 32px;
    //}
  }

  .add-step {
    margin: 0;
    padding: 0;
    border: none;
    opacity: 0.5;
    cursor: pointer;
    background: none;

    &:hover {
      opacity: 1;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &.dragging {
    .row.add-sequence {
      display: flex;
    }
  }

  .buttons {
    display: flex;
    column-gap: 8px;
    margin-top: 16px;
    flex-direction: row;
  }

  .empty {
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 5px;

    svg {
      width: 16px;
      height: 16px;
      stroke: #666666;
      margin-bottom: 2px;
      display: inline-block;
    }
  }

  .sequence-roles {
    display: flex;
    max-width: 400px;
  }

  ::placeholder {
    color: $verdocs-bg-2;
  }
}
